import { Box } from "@chakra-ui/layout";
import { useCurrentTenant } from "features/auth/tenant.store";
import { useState } from "react";
import SelectBaseAntd, {
  SelectBaseAntdProps,
} from "components/Input/SelectBaseAntd";
import useGetTenantUsuariosSimples from "./../../../../core/features/tenants/hooks/useGetTenantUsuariosSimples";

export interface SelectUsuarioResponsavelProps<T = any>
  extends SelectBaseAntdProps<T> {
  value: T | undefined;
  onChange: (v: any, option?: any) => void;
  perfilId?: string;
}

function SelectUsuarioResponsavel({
  value,
  onChange,
  isInvalid,
  perfilId,
  ...rest
}: SelectUsuarioResponsavelProps) {
  const { tenant } = useCurrentTenant();
  const [search, setSearch] = useState<string>();

  const { isLoading, isFetching, data } = useGetTenantUsuariosSimples({
    tenantId: tenant.id,
    limit: 9999,
    page: 1,
    perfilId,
  });

  const _isLoading = isLoading || isFetching;

  return (
    <>
      <SelectBaseAntd
        isInvalid={isInvalid}
        loading={isLoading || isFetching}
        size="large"
        placeholder="Selecione o usuário"
        style={{ width: "100%" }}
        value={value}
        onChange={onChange}
        allowClear={false}
        {...rest}
        showSearch
        searchValue={search}
        onSearch={setSearch}
        optionFilterProp="label"
        options={data?.items.map((item) => ({
          value: item.id,
          label: item.nome,
        }))}
        notFoundContent={
          !_isLoading ? (
            <Box>Nenhum usuário encontrado</Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectUsuarioResponsavel;
